import { ProgressBar } from '@shared/ui/progress-bar';

import { formatMillionWon } from '../lib/fund-format';
import type { InvestmentGoal } from '../model/investment-goal';
import { FUND_TARGET_ITEM_TEXT } from './fund-target-item.text';

export interface FundTargetItemProps {
  goal: InvestmentGoal;
}

/** 투자 목적 하나의 목표 대비 달성률: 이름 + 투자 금액 / 목표 금액 (퍼센트) + 진행 막대 */
export function FundTargetItem({ goal }: FundTargetItemProps) {
  const name = goal.isMajor ? FUND_TARGET_ITEM_TEXT.major : goal.name;
  // 목표가 없으면(null) 금액 "-" · 달성률 계산 안 함(기존 서비스 "0 / -")
  const percent =
    goal.volumeTarget !== null && goal.volumeTarget > 0
      ? Math.round((100 * goal.volumeInvested) / goal.volumeTarget)
      : null;
  const percentText = percent === null ? FUND_TARGET_ITEM_TEXT.notAvailable : `${percent}%`;

  return (
    <div className="flex w-full flex-col gap-2-5">
      <div className="flex items-center justify-between">
        <span className="text-fg-default typo-caption-strong">{name}</span>
        <span className="flex items-center whitespace-pre">
          <span className="text-fg-primary typo-micro-strong">
            {formatMillionWon(goal.volumeInvested)}
          </span>
          <span className="text-fg-default typo-micro">
            {` / ${formatMillionWon(goal.volumeTarget)} (${percentText})`}
          </span>
        </span>
      </div>
      <ProgressBar
        value={percent === null ? 0 : Math.min(100, percent)}
        aria-label={name}
        aria-valuetext={percent === null ? FUND_TARGET_ITEM_TEXT.notAvailable : undefined}
      />
    </div>
  );
}
